<template>
  <v-card class="pa-2 mb-4">
    <v-card-title class="text-h6 mt-2 mb-2">
      <h4 class="mb-0">
        <strong>Estado del Proceso</strong>

      </h4>
    </v-card-title>
    <v-card-text>
      <div class="space-y-3">
        <div
          v-for="({ key, label, step: stepNum }) in steps"
          :key="key"
          :class="[
            'd-flex align-center ga-2',
            getStepClass(key)
          ]"
        >
          <v-avatar
            :color="getStepColor(key)"
            size="24"
          >
            <span class="text-caption font-weight-bold">
              {{ stepNum }}
            </span>
          </v-avatar>
          <span class="text-body-2">{{ label }}</span>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ProcessSteps',
  props: {
    currentStep: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      steps: [
        { key: "scan", label: "Escanear LPN", step: 1 },
        { key: "select-order", label: "Seleccionar Pedido", step: 2 },
        { key: "validate", label: "Validar Items", step: 3 },
        { key: "package", label: "Empaquetar", step: 4 },
        { key: "complete", label: "Completado", step: 5 },
      ]
    }
  },
  methods: {
    getStepClass(stepKey) {
      if (this.currentStep === stepKey) {
        return 'text-primary'
      } else if (this.isStepCompleted(stepKey)) {
        return 'text-success'
      } else {
        return 'text-medium-emphasis'
      }
    },
    getStepColor(stepKey) {
      if (this.currentStep === stepKey) {
        return 'primary'
      } else if (this.isStepCompleted(stepKey)) {
        return 'success'
      } else {
        return 'grey-lighten-1'
      }
    },
    isStepCompleted(stepKey) {
      const stepOrder = ["scan", "select-order", "validate", "package", "complete"]
      const currentIndex = stepOrder.indexOf(this.currentStep)
      const stepIndex = stepOrder.indexOf(stepKey)
      return currentIndex > stepIndex
    }
  }
}
</script>

<style scoped>
.space-y-3 > * + * {
  margin-top: 12px;
}
</style>